import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface MerchantIdFormData {
  merchantId: string;
}

@Component({
  selector: 'app-merchant-id-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './merchant-id-dialog.component.html',
  styleUrls: ['./merchant-id-dialog.component.css']
})
export class MerchantIdDialogComponent implements OnInit, OnChanges {

  @Input() isVisible: boolean = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();
  @Output() merchantIdSubmit = new EventEmitter<string>();

  formData: MerchantIdFormData = {
    merchantId: ''
  };

  merchantIdError: string = '';

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isVisible) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.merchantIdError = '';
    this.formData = {
      merchantId: ''
    };
  }

  get dialogTitle(): string {
    return 'Enter the Merchant ID';
  }

  close(): void {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
    this.closed.emit();
    this.resetForm();
  }

  handleSubmit(): void {
    if (!this.isFormValid()) {
      return;
    }

    this.merchantIdSubmit.emit(this.formData.merchantId.trim());
    this.close();
  }

  handleCancel(): void {
    this.close();
  }

  handleBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  validateMerchantId(): void {
    const merchantId = this.formData.merchantId.trim();
    
    if (!merchantId) {
      this.merchantIdError = '';
      return;
    }

    // Basic validation - you can adjust this based on your requirements
    if (merchantId.length < 3) {
      this.merchantIdError = 'Merchant ID must be at least 3 characters';
      return;
    }

    this.merchantIdError = '';
  }

  isFormValid(): boolean {
    return this.formData.merchantId.trim().length > 0 && !this.merchantIdError;
  }

  private resetForm(): void {
    this.formData = {
      merchantId: ''
    };
    this.merchantIdError = '';
  }
}
